import React from 'react';

import { useStyletron } from '../../../Themes';

function Title({ onClickProductName, className, ...props }: any) {
    const [css]: any = useStyletron();

    const onClick = (event: MouseEvent) => {
        if (onClickProductName) {
            onClickProductName(event);
        }
    };

    const basicClassname = `${css({
        margin: '0 var(--epods--header-menu-margin-right)',
        fontWeight: 100,
        fontFamily: 'var(--epods--font-base-semibold)',
        paddingRight: '0',
        whiteSpace: 'nowrap',
    })}`
    const headerClassname = className ? `${className} ${basicClassname}` : `${basicClassname}`;

    return (
        <span
            {...props}
            onClick={(event: any) => onClick(event)}
            className={headerClassname}
        ></span>
    );
};

export default Title;